
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.25 16.875h17.5M11.25 16.875V3.125a.625.625 0 00-.625-.625h-7.5a.625.625 0 00-.625.625v13.75M17.5 16.875v-8.75a.625.625 0 00-.625-.625H11.25M5 5.625h2.5M6.25 10.625h2.5M5 13.75h2.5M13.75 13.75H15M13.75 10.625H15","stroke":"#3A3D58","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    